import React from 'react'
import { FaBasketballBall, FaBuffer } from 'react-icons/fa'
import { MdCalendarMonth, MdOutlineCalendarMonth } from "react-icons/md";
import { IoToday } from "react-icons/io5";
import { FaArrowRightArrowLeft } from "react-icons/fa6";
import withAuth from '../../utils/withAuth';

const DashboardSection = () => {
    
    return (
        <div className="dashboardsection">
            <div className="radius-10 overflow-hidden w-100 taemp">
                <div className="icons">
                    <IoToday />
                </div>
                <div className="ordertype">
                    <span>Total Active Employee</span>
                </div>
                <div className="ordervalue">
                    <h2>654</h2>
                    <small><FaArrowRightArrowLeft /> 3254</small>
                </div>
            </div>
            <div className="radius-10 overflow-hidden w-100 tticket">
                <div className="icons">
                    <FaBuffer />
                </div>
                <div className="ordertype">
                    <span>Total Ticket</span>
                </div>
                <div className="ordervalue">
                <h2>6598</h2>
                    <small><FaArrowRightArrowLeft /> 987</small>
                </div>
            </div>
            <div className="radius-10 overflow-hidden w-100 mbirth">
                <div className="icons">
                    <MdCalendarMonth />
                </div>
                <div className="ordertype">
                    <span>This Month Birthday</span>
                </div>
                <div className="ordervalue">
                <h2>365</h2>
                    <small><FaArrowRightArrowLeft /> 23</small>
                </div>
            </div>
            <div className="radius-10 overflow-hidden w-100 manv">
                <div className="icons">
                    <MdOutlineCalendarMonth />
                </div>
                <div className="ordertype">
                    <span>This Month Aniversary</span>
                </div>
                <div className="ordervalue">
                    <h2>256</h2>
                    <small><FaArrowRightArrowLeft /> 1254</small>
                </div>
            </div>
            <div className="radius-10 overflow-hidden w-100 temp">
                <div className="icons">
                    <FaBasketballBall />
                </div>
                <div className="ordertype">
                    <span>Total Employee</span>
                </div>
                <div className="ordervalue">
                <h2>254</h2>
                    <small><FaArrowRightArrowLeft /> 254</small>
                </div>
            </div>
        </div>
    )
}

export default withAuth(DashboardSection)